import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UpgradeArrow = () => /*#__PURE__*/_jsxs("svg", {
  "data-test-id": "hs-upgrade-arrow",
  viewBox: "0 0 12.83 12.83",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "14px",
  children: [/*#__PURE__*/_jsx("mask", {
    id: "upgradeArrow",
    height: "12.83",
    maskUnits: "userSpaceOnUse",
    width: "12.83",
    x: "0",
    y: "0",
    children: /*#__PURE__*/_jsx("path", {
      d: "m0 0h12.83v12.83h-12.83z",
      fill: "#fff",
      fillRule: "evenodd"
    })
  }), /*#__PURE__*/_jsx("g", {
    mask: "url(#upgradeArrow)",
    children: /*#__PURE__*/_jsx("path", {
      d: "m6.42 0a6.42 6.42 0 1 0 6.41 6.42 6.41 6.41 0 0 0 -6.41-6.42",
      fill: "#e66e50",
      fillRule: "evenodd"
    })
  }), /*#__PURE__*/_jsx("g", {
    mask: "url(#upgradeArrow)",
    children: /*#__PURE__*/_jsx("path", {
      d: "m10 6.08a.6.6 0 0 1 -1 0l-2-2v6.29c0 .49-.13.69-.68.69s-.69-.12-.69-.69v-6.26l-2 2a.61.61 0 0 1 -1 0 .57.57 0 0 1 0-1l3.22-3.11a.68.68 0 0 1 1 0l3.15 3.11a.59.59 0 0 1 0 1",
      fill: "#fff",
      fillRule: "evenodd"
    })
  })]
});
export default UpgradeArrow;